import React from "react";
import { useI18n } from "../i18n/I18nContext";

export default function Terms() {
  const { t, raw } = useI18n();
  const sections = raw("pages.terms.sections") || [];
  return (
    <main data-testid="terms-page" className="bg-white">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-10 lg:py-24">
        <h1
          className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl"
          style={{ fontFamily: "'Cabinet Grotesk', 'IBM Plex Sans', sans-serif" }}
        >
          {t("pages.terms.title")}
        </h1>
        <p className="mt-2 text-sm font-medium uppercase tracking-widest text-slate-500">
          {t("pages.terms.updated")}
        </p>
        <p className="mt-6 text-base leading-relaxed text-slate-700">
          {t("pages.terms.intro")}
        </p>
        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-semibold text-slate-900">{s.title}</h2>
              <p className="mt-2 text-base leading-relaxed text-slate-700">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
